import React, { ReactNode, useState } from 'react';
import { AppBar, Box, Tab, Tabs, Typography } from '@mui/material';

import { hasSealsAndSignaturesPermission as hasSealsAndSignaturesPermissionSelector } from '@paragon/login-tools';

import { loggedInUser } from '../../selectors/users';
import { useAppSelector } from '../hooks';
import { SealEditor } from '../seals-and-signatures/SealEditor';
import { SignatureList } from '../seals-and-signatures/SignatureList';
import ChangePassword from './ChangePassword';
import EditSelf from './EditSelf';

interface Props {
  readonly children: ReactNode;
}

function TabContainer({ children }: Props) {
  return (
    <Typography component="div" sx={{ p: { xs: 1, sm: 3 } }}>
      {children}
    </Typography>
  );
}

export function PersonalSettings() {
  const user = useAppSelector((state) => loggedInUser(state));
  const hasSealsAndSignaturesPermission = useAppSelector(hasSealsAndSignaturesPermissionSelector);

  const [value, setValue] = useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, value: number) => {
    setValue(value);
  };

  return user ? (
    <div>
      <AppBar enableColorOnDark position="static">
        <Tabs
          indicatorColor="secondary"
          textColor="inherit"
          centered
          variant="fullWidth"
          value={value}
          onChange={handleChange}
        >
          <Tab label="Personal Information" />
          {hasSealsAndSignaturesPermission ? <Tab label="Seals & Signatures" /> : null}
        </Tabs>
      </AppBar>
      {value === 0 && (
        <TabContainer>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              flexWrap: { md: 'wrap' },
              justifyContent: 'space-evenly',
            }}
          >
            <EditSelf />
            <ChangePassword />
          </Box>
        </TabContainer>
      )}
      {hasSealsAndSignaturesPermission
        ? value === 1 && (
            <TabContainer>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  flexWrap: { md: 'wrap' },
                  justifyContent: 'space-evenly',
                }}
              >
                <SealEditor user={user} />
                <SignatureList user={user} />
              </Box>
            </TabContainer>
          )
        : null}
    </div>
  ) : null;
}
